"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const immutable_1 = require("immutable");
const budgetsTypes_1 = require("companion-app-components/flux/budgets/budgetsTypes");
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const BudgetGroupItem_1 = __importDefault(require("./BudgetGroupItem"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const BudgetGroupHeader = ({ classes, onClick, node, currency, accountIds }) => {
    const isRollupRow = (node.depth > 0);
    return (<ButtonBase_1.default style={{ width: '100%' }} onClick={onClick} href="" focusRipple>
      <BudgetGroupItem_1.default item={{ amount: node.targetAmount,
            name: !isRollupRow ? node.displayLabel.toUpperCase() : node.displayLabel,
            isIncome: node.targetAmount > 0,
            id: node.id,
            budgetedWithChild: true,
        }} currency={currency} accountIds={accountIds} isRollup classesPassed={{ categoryRow: isRollupRow ? '' : classes.rootNode, categoryName: classes.categoryName }} depth={isRollupRow ? 0 : -1}/>
    </ButtonBase_1.default>);
};
const EditBudgetCategoryGroups = ({ currency, budgetTreeNodes, onChange, onDelete, accountIds }) => {
    // @ts-expect-error: Only a void function can be called with the 'new' keyword.
    const [hiddenGroups, setHiddenGroups] = (0, react_1.useState)(new immutable_1.Set());
    const { classes } = useStyles();
    const showHideGroup = (node) => {
        setHiddenGroups(hiddenGroups.has(node.id) ? hiddenGroups.delete(node.id) : hiddenGroups.add(node.id));
    };
    const getInnerNodes = (nodes, depth = 0) => {
        let localNodeList = [];
        nodes.forEach((node) => {
            let overrideLabel = null;
            if (node.type === budgetsTypes_1.BudgetNodeTypes.GROUP_EE) {
                overrideLabel = node.displayLabel;
            }
            localNodeList.push(<react_1.default.Fragment key={`budgetNode:${node.id}${node.displayLabel}${node.type}`}>
          {((node.depth === 0) || node.type === 'crup') &&
                    <BudgetGroupHeader classes={classes} onClick={() => showHideGroup(node)} node={node} currency={currency} accountIds={accountIds}/>}
          {(node.depth) > 0 && !hiddenGroups.has(node.id) && node.budgetItems.size > 0 &&
                    <BudgetGroupItem_1.default item={node.budgetItems.first()} chartIds={node.coas} currency={currency} onChange={onChange} onDelete={node.type === budgetsTypes_1.BudgetNodeTypes.GROUP_EE ? undefined : onDelete} accountIds={accountIds} overrideLabel={overrideLabel} depth={depth - 1 - (node.type === budgetsTypes_1.BudgetNodeTypes.GROUP_EE ? 1 : 0)} isEverythingElse={node.isEverythingElse && node.type !== budgetsTypes_1.BudgetNodeTypes.GROUP_EE}/>}
        </react_1.default.Fragment>);
            if ((node.children.size > 0) && !hiddenGroups.has(node.id)) {
                localNodeList = localNodeList.concat(getInnerNodes(node.children, depth + 1));
            }
        });
        return localNodeList;
    };
    // RENDER
    // Build inner nodes using a sequencer to avoid React errors (does not support Map)
    // if (budgetTreeNodes) console.log ("NODE LIST ", budgetTreeNodes.toJS());
    const innerNodes = getInnerNodes(budgetTreeNodes);
    return innerNodes && innerNodes.length ? (<div style={{ overflowY: 'scroll' }}>
      {innerNodes}
    </div>) : null;
};
exports.default = EditBudgetCategoryGroups;
